<template>
    <div class="text-editor">
      <h2>Text auf der Startseite bearbeiten:</h2>
      <div v-if="textData">
        <div>
          <label for="textHead">Text Head:</label>
          <input type="text" v-model="textData.text_head" id="textHead" />
        </div>
        <div>
          <label for="textBlock">Text Block:</label>
          <textarea v-model="textData.text_block" id="textBlock" rows="5"></textarea>
        </div>
        <button @click="saveChanges">Save Changes</button>
      </div>
      <div v-else>
        <p>Loading...</p>
      </div>
      <div v-if="textData">
        <h3>Preview:</h3>
        <h2 v-html="textData.text_head"></h2>
        <div v-html="textData.text_block"></div>
      </div>
    </div>
  </template>
  
  <script>
  import admin from '../../api/admin';

  export default {
    data() {
      return {
        textData: null,
      };
    },
    created() {
      this.fetchTextData();
    },
    methods: {
        fetchTextData(){
            this.loading = true;

            admin.getTextsFromServer(
                this,
                data => this.textData = data.text,
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );

        },
        saveChanges(){
            this.loading = true;

            admin.postTextsToServer(
                this,
                JSON.parse(JSON.stringify(this.textData)),
                () => alert('Changes saved successfully!'),
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            )
        },

      async saveChangesa() {

        // Replace with your API endpoint to save the text data
        await fetch(`/api/kgk_texts/${this.textData.identifier}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.textData),
        });
        alert('Changes saved successfully!');
      },
    },
  };
  </script>
  
  <style scoped>
  .text-editor {
    max-width: 600px;
    margin: auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f9f9f9;
  }
  
  h2, h3 {
    color: #333;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
  }
  
  input[type="text"],
  textarea {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  button {
    padding: 10px 15px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #218838;
  }
  </style>